<template>
    <div class="container">
        <!-- Header -->
        <div class="row mb-3">
            <h4 class="text-font me-3">Prontuário</h4>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="search-bar">
                        <input v-model="inputValueSearch" type="search"
                               class="form-control text-font-regular background-search"
                               aria-describedby="search-addon"
                               placeholder="Buscar paciente"
                               aria-label="Buscar paciente"
                               @keydown.enter.prevent="handleSearch"
                               v-on:search="clearSearch"/>
                        <div class="clear-button"></div>
                        <button class="search-button" @click="handleSearch">
                            <img src="../assets/search-icon-white.svg" alt="Ícone de pesquisa">
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isLoading" class="text-center mt-3">
            <div class="spinner-border" role="status">
                <span class="visually-hidden">Carregando...</span>
            </div>
            <p class="mt-4">Carregando...</p>
        </div>
        <div v-else-if="searched && filteredPatients.length > 0" class="container">
            <div v-for="(patient, index) in filteredPatients" :key="index" class="card mt-2">
                <div class="card-header">
                    Paciente: {{ patient.name }}
                </div>
                <div class="card-body">
                <p v-if="patient.document_type" class="card-text"><span class="info-label">{{ patient.document_type }}:</span>
                    {{ patient.document }}</p>
                <p class="card-text"><span class="info-label">Data de Nascimento:</span> {{ patient.birthdate }}
                    ({{ calculateAge(patient.birthdate) }} Anos)</p>
                <button class="btn btn-primary" @click="showPatientRecord(patient)">
                    Ver Prontuário
                </button>
                </div>
            </div>
        </div>
        <div v-else-if="searched" class="text-center mt-2 fw-bold">
            <i class="bi bi-folder2-open fs-1" />
            <p>Nenhum paciente encontrado.</p>
            <p>Refaça sua pesquisa acima.</p>
        </div>
        <div v-else class="text-center mt-2 fw-bold">
            <i class="bi bi-search fs-1" />
            <p>Digite o nome do paciente na barra acima para realizar sua busca.</p>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";


export default {
    name: "MedicalRecord",
    computed: {
        ...mapGetters({User: "StateUser"}),
        filteredPatients() {
            return this.patientsList;
        },
    },
    data() {
        return {
            inputValueSearch: "",
            isLoading: false,
            searched: false,
            patientsList: [],
        };
    },
    created() {
        if (!this.isAuthenticated()) {
            this.$router.push("/login");
        }
    },
    methods: {
        ...mapGetters(["isAuthenticated"]),
        ...mapActions(["GetPatientList"]),
        clearSearch() {
            this.inputValueSearch = "";
            this.searched = false;
            this.patientsList = [];
        },
        async handleSearch() {
            if (!this.inputValueSearch || this.inputValueSearch.trim().length < 2) return;

            this.isLoading = true;
            this.searched = false;
            try {
                let result = await this.GetPatientList({name: this.inputValueSearch});
                if (result && result.data && result.data.patients_info) {
                    this.patientsList = result.data.patients_info;
                } else {
                    this.patientsList = [];
                }
            } catch (error) {
                console.error("Erro ao buscar pacientes:", error);
                this.patientsList = [];
            }

            this.isLoading = false;
            this.searched = true;
        },
        calculateAge(birthdate) {
            if (!birthdate) return "";
            let day, month, year;
            if (birthdate.includes("-")) {
                // Assume YYYY-MM-DD
                [year, month, day] = birthdate.split("-").map(Number);
            } else {
                // Assume DD/MM/YYYY
                [day, month, year] = birthdate.split("/").map(Number);
            }
            const today = new Date();
            const birth = new Date(year, month - 1, day);
            let age = today.getFullYear() - birth.getFullYear();
            const hasHadBirthdayThisYear =
                today.getMonth() > birth.getMonth() ||
                (today.getMonth() === birth.getMonth() && today.getDate() >= birth.getDate());
            if (!hasHadBirthdayThisYear) age--;
            return age;
        },
        showPatientRecord(patient) {
            this.$router.push({
                name: "MedicalRecordDetail",
                state: {patient: JSON.stringify(patient)},
            });
        },
    },
};
</script>

<style scoped>
.clear-button {
    margin-left: 44px;
}

.search-bar {
    display: flex;
    align-items: center;
    background-color: #f0f0f0;
    border-radius: 20px;
    position: relative;
}

.search-button {
    height: 36px;
    width: 40px;
    background-color: #6200EE;
    border: none;
    border-radius: 0 8px 8px 0;
    cursor: pointer;
    position: absolute;
    right: 0;
}

.search-button img {
    width: 20px;
    height: 20px;
    margin-bottom: 1px;
    object-fit: cover;
}

.search-bar i {
    margin-right: 10px;
}

.search-bar input[type="search"] {
    flex: 1;
    border: none;
    outline: none;
}

.background-search {
    background-color: #f0f0f0;
}

.text-font {
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    color: #777777;
}

</style>
